{
  "about": "About",
  "accept": "Accept",
  "accept_all": "Accept all",
  "access": "Access",
  "access_management": "Access Management",
  "access_type": "Access Type",
  "accumulated_energy": "Accumulated",
  "action_center_actions_assign_to": "Assign To",
  "action_center_actions_change_priority": "Change Priority",
  "action_center_actions_change_status": "Change Status",
  "action_center_actions_delete": "Delete",
  "action_center_actions_link_assets": "Link Assets",
  "action_center_actions_link_classification": "Link Classification",
  "action_center_actions_link_files": "Link Files",
  "action_center_actions_link_incidents": "Link Incidents",
  "action_center_actions_link_requests": "Link Requests",
  "action_center_actions_link_work_orders": "Link Work Orders",
  "action_center_actions_set_approver": "Set Approver",
  "action_center_actions_set_category": "Set Category",
  "action_center_actions_set_document_type": "Set Document Type",
  "action_center_actions_set_due_date": "Set Due Date",
  "action_center_actions_set_label": "Set Label",
  "action_center_actions_set_location": "Set Location",
  "action_center_actions_set_schedule": "Set Schedule",
  "action_center_apply": "Apply",
  "action_center_back": "Back",
  "action_center_categories_automation": "Automation",
  "action_center_categories_building": "Building",
  "action_center_categories_electrical": "Electrical",
  "action_center_categories_fire": "Fire",
  "action_center_categories_heating_and_cooling": "Heating & Cooling",
  "action_center_categories_outdoor": "Outdoor",
  "action_center_categories_piping": "Piping",
  "action_center_categories_safety": "Safety",
  "action_center_categories_sanitary": "Sanitary",
  "action_center_categories_ventilation": "Ventilation",
  "action_center_delete_confirmation": "{count, plural, other {Are you sure you want to delete <b># {type}s</b>?} =1 {Are you sure you want to delete <b># {type}</b>?}}",
  "action_center_navigate": "to Navigate",
  "action_center_select": "to Select",
  "action_center_select_all": "Select all",
  "action_center_smart_suggest_auto_tagging": "Auto Tagging",
  "action_center_smart_suggest_auto_tagging_description": "Attempts to identify document type and classification based on file name",
  "action_center_smart_suggest_classify_files": "Classify Files",
  "action_center_smart_suggest_classify_files_description": "Uses AI to automatically classify files based on their content",
  "action_center_smart_suggest_title": "Smart Suggest",
  "action_center_tooltips_actions": "Actions",
  "action_center_tooltips_make_copy": "Make a copy",
  "action_center_tooltips_mark_completed": "Mark as Completed",
  "action_center_tooltips_show_in_twin": "Show in Twin",
  "action_center_tooltips_smart_suggest": "Smart Suggest",
  "actions": "Actions",
  "activity": "Activity",
  "actual": "Actual",
  "add": "Add",
  "add_asset": "Add Asset",
  "add_checklist": "Create checklist",
  "add_checklist_item": "Add checklist item",
  "add_checklist_routine_info": "Add one or more checklist items. The order can be edited with drag and drop.",
  "add_classifications": "Add classifications",
  "add_component": "Add a component",
  "add_component_instruction": "Add a component using \"+\" button on the right",
  "add_contact": "Add contact",
  "add_contacts": "Add contacts",
  "add_data_point": "Add data point",
  "add_data_points_description": "Add data points for easy data tracking and management",
  "add_description": "Add a description",
  "added_new_room": "You've added new room",
  "add_entity": "Add entity",
  "add_existing": "Add existing",
  "add_existing_asset": "Add existing asset",
  "add_existing_incident": "Add existing Incident",
  "add_existing_request": "Add existing request",
  "add_existing_work_order": "Add existing Work Order",
  "add_file": "Add file",
  "add_files": "Add files",
  "add_filters": "Add filters",
  "add_floors": "Add Floors",
  "add_incident": "Add Incident",
  "add_installation_cost": "Add cost of installation",
  "add_internal_comment": "Add internal comment",
  "add_location": "Add a location",
  "add_lock_vendor": "Add lock vendor",
  "add_new": "Add New",
  "add_new_asset": "Add new asset",
  "add_new_building": "Add new building",
  "add_new_file": "Add new file",
  "add_new_org": "Add new organization",
  "add_new_request": "Add new request",
  "add_new_sensor": "Add new sensor",
  "add_new_team": "Add new team",
  "add_new_user": "Add new user",
  "add_new_value": "Add a new value",
  "add_new_zone": "Add new zone",
  "add_note": "Add note",
  "add_org": "Add organization",
  "add_page": "Add page",
  "add_picture": "Add picture",
  "add_product_name": "Add product name",
  "add_property": "Add property",
  "address": "Address",
  "address_in_use_warning": "This address is already assigned to another building. Please adjust the green marker for the new building on the map",
  "add_room": "Add Room",
  "add_rooms": "Add rooms",
  "add_rooms_to_floor": "Add rooms to {floorName}",
  "add_room_title": "Add Room",
  "add_sensor": "Add Sensor",
  "add_serial_number": "Add serial number",
  "add_task": "Add task",
  "add_team": "Add team",
  "add_team_to_organization": "Add Team to Organization",
  "add_test": "Add test",
  "add_title": "Add title",
  "add_to_favorites": "Add to favorites",
  "add_to_room": "Add to room",
  "add_twin_for": "Add Twin for",
  "add_user": "Add User",
  "add_value_success": "Value added successfully",
  "add_work_order": "Add Work Order",
  "add_zone": "Add Zone",
  "adjust_floors_height": "Adjust Floors Height",
  "admin": "Admin",
  "administrator": "Administrator",
  "administrators": "Administrators",
  "advanced_mode": "Advanced Mode",
  "advanced_mode_description": "Get access to all features",
  "ai_analysis_description": "Our AI tool analyzes your uploaded images to help create and populate asset information automatically. The AI can identify equipment types, read text from labels, and extract relevant details to save you time.",
  "ai_analysis_title": "How does it work?",
  "ai_assistant": "AI assistant",
  "ai_disclaimer_title": "Results Accuracy",
  "ai_enriching_asset_data": "Enriching asset with data",
  "ai_extracting_asset_details": "Extracting asset details with AI magic",
  "ai_generated_content_warning": "Content is AI-generated and should be verified before saving",
  "ai_identifying_key_features": "Identifying key features from the images",
  "ai_image_analysis": "AI assistant with image analysis",
  "ai_image_analysis_error": "Something went wrong when analysing your image.",
  "ai_image_tips_angles_description": "Take several pictures from different angles. This helps the AI get a complete understanding of the object and its surroundings",
  "ai_image_tips_angles_title": "Multiple Angles are Better",
  "ai_image_tips_footer": "Following these tips will help improve the accuracy of the AI image analysis",
  "ai_image_tips_general_description": "Keep the camera steady to avoid blurry images. Focus on the object of interest and ensure it's the main subject in the frame. Clear, focused images provide the best results for AI analysis",
  "ai_image_tips_general_title": "General Photography Tips",
  "ai_image_tips_labels_description": "Take clear photos of any labels showing brand, model name or number, serial number, or other identifying information. Ensure the text is visible and readable in the image",
  "ai_image_tips_labels_title": "Capture Labels and Identifiers",
  "ai_image_tips_lighting_description": "Ensure the area is well-lit. Avoid shadows or glare that might obscure details. Natural light is often best, but use flash if necessary",
  "ai_image_tips_lighting_title": "Good Lighting is Key",
  "ai_image_tips_title": "Tips for AI Image Analysis",
  "ai_image_upload_description": "Upload images, and we’ll help you analyze and enrich the asset using AI – based on both the images and existing data in the solution.",
  "ai_image_upload_title": "AI image analysis",
  "ai_info_dialog_footer": "Have any questions? Send us a message via intercom in the bottom right corner, and we'll help you!",
  "ai_language_description": "The AI assistant will generate results in the language configured in your Autility profile settings. You can change your language preferences in Edit Profile",
  "ai_language_title": "Language Support",
  "ai_magic_dust_message": "Sprinkling AI magic dust",
  "ai_privacy_notice": "Your data privacy is important to us. Our AI model is hosted in Europe and operates in compliance with GDPR. The images you upload are not used for training the AI model.",
  "ai_privacy_title": "Data Privacy",
  "ai_results_disclaimer": "As with any AI technology, the analysis results may vary in accuracy. We recommend reviewing the generated information before saving",
  "ai_saving_time_message": "Helping you save time to do more important things",
  "ai_suggestion": "AI Suggestion",
  "all": "All",
  "all_assets": "All Assets",
  "all_buildings": "All buildings",
  "all_categories": "All Categories",
  "all_comfort_levels": "All Comfort Levels",
  "all_data_will_be_lost": "All your data will be lost.",
  "all_floors": "All floors",
  "all_levels": "All Levels",
  "all_months": "All Months",
  "allowed_formats": "Allowed formats: {formats}",
  "allowed_formats_with_ifc": "Allowed formats: GLTF, GLB, DXF, JPG, JPEG, PDF. IFC files can be uploaded from action menu in All Floors",
  "all_statuses": "All statuses",
  "all_types": "All Types",
  "analysis_completed": "Analysis completed",
  "analyze_existing_text": "Analyze existing",
  "analyze_existing_tooltip": "Analyze existing images to find more information about the asset. Existing data will be used in the analysis",
  "analyze_new_title": "Upload images",
  "analyze_new_tooltip": "Upload images to analyze and find information about the asset. Existing data will not be used in the analysis",
  "analyzing": "Analyzing",
  "analyzing_images": "Analyzing image",
  "analyzing_status": "Analyzing",
  "and_count_more": "And {count} more",
  "any": "Any",
  "apply": "Apply",
  "approved": "Approved",
  "approver": "Approver",
  "april": "April",
  "area": "Area",
  "asignee": "Assignee",
  "ask_me": "Ask me",
  "asset": "Asset",
  "asset_name": "Asset Name",
  "assets": "Assets",
  "assets_count": "Assets Count",
  "assets_deleted": "{count, plural, one {# asset has been deleted successfully} other {# assets have been deleted successfully}}",
  "asset_view_label": "Label",
  "assigned": "Assigned",
  "assignee": "Assignee",
  "assignee_filter": "Assignee",
  "attach": "Attach",
  "attached_assets": "Attached assets",
  "attached_files": "Attached files",
  "attached_incidents": "Attached incidents",
  "attached_requests": "Attached requests",
  "attached_tasks": "Attached tasks",
  "attached_work_orders": "Attached work orders",
  "attach_existing_incidents": "Attach existing incidents",
  "attachment_workspace": "Attachment Workspace",
  "attach_work_order": "Attach work order",
  "august": "August",
  "autility_agreement_prefix": "By using Autility's services you hereby agree to the ",
  "autility_users": "Autility Users",
  "automation": "Automation",
  "available": "Available",
  "awaiting_approval": "Awaiting Approval",
  "back": "Back",
  "bad": "Bad",
  "bedroom": "Bedroom",
  "benchmark": "Benchmark",
  "benchmark_thirty_days": "Benchmark (30 days)",
  "beta_functions": "Beta Functions",
  "beta_functions_description": "You have access to all features",
  "bim": "BIM",
  "build": "Build",
  "building": "Building",
  "building_added_successfully": "You've added a new Building",
  "building_component_table": "Building Component Table",
  "building_configuration": "Building Configuration",
  "building_configuration_description": "Add rooms and change floors, rooms, assets and systems",
  "building_create_error": "Can't create Building",
  "building_filter": "Buildings",
  "building_image": "Building image",
  "building_image_updated": "Building image updated successfully",
  "building_info": "Building info",
  "building_name": "Building Name",
  "buildings": "Buildings",
  "building_square_meters": "Square meters",
  "building_type": "Choose status for the location",
  "cache_limit": "Cache limit",
  "calculate_length": "Calculate Length by double click, press delete to remove measurements",
  "calendar": "Calendar",
  "calendar_disabled_status": "Calendar is disabled",
  "calendar_view": "Calender view",
  "calender_view": "Calender View",
  "cancel": "Cancel",
  "cancelled": "Canceled",
  "cancel_upload": "Cancel upload",
  "cannot_create_zone": "Cannot create zone",
  "cannot_create_zone_no_assets": "Can't create a zone without selected assets",
  "cannot_edit_zone": "Cannot edit zone",
  "can_not_save_coordinates": "Can't save coordinates",
  "cant_create_room": "Can't create room",
  "cant_select_team": "Can't select team",
  "cant_update_floor_name": "Can't update floor name",
  "cant_update_room": "Can't update room",
  "capabilities": "Capabilities",
  "categories_automation": "Automation",
  "categories_building": "Building",
  "categories_electrical": "Electrical",
  "categories_fire": "Fire",
  "categories_heating_and_cooling": "Heating & Cooling",
  "categories_outdoor": "Outdoor",
  "categories_piping": "Piping",
  "categories_safety": "Safety",
  "categories_sanitary": "Sanitary",
  "categories_ventilation": "Ventilation",
  "category": "Category",
  "category_automation": "Automation",
  "category_building": "Building",
  "category_electrical": "Electrical",
  "category_fire": "Fire",
  "category_heating_and_cooling": "Heating and cooling",
  "category_none": "None",
  "category_outdoor": "Outdoor",
  "category_piping": "Piping",
  "category_safety": "Safety",
  "category_sanitary": "Sanitary",
  "category_ventilation": "Ventilation",
  "change_address_on_marker_move": "Change address when moving marker",
  "change_building_location_warning": "Click here if you are sure you want to change Building location",
  "change_language": "Change language",
  "change_password": "Change password",
  "change_password_prefix": "We just sendt a magic link to your email",
  "change_room_type": "Change Room Type",
  "change_search_placeholder": "To change or empty the filter, click the filterbutton. Click \"+\" to add a new task",
  "changes_made_successfully": "Changes were made successfully",
  "chatbot_cannot_process_request": "Cannot process your request",
  "chatbot_close_sidebar": "Close sidebar",
  "chatbot_new_chat": "New Chat",
  "chatbot_no_building_selected_warning": "Sorry, I can't proceed your request without defined building. Please select a building first",
  "chatbot_open_sidebar": "Open sidebar",
  "chatbot_preview_msg": "Ask me anything",
  "chatbot_start_new_chat": "Start a new chat",
  "chatbot_title": "Ask your building",
  "chatbot_welcome_msg": "Feel free to inquire about any building-related queries through this AI chat. To begin, simply specify the building you're interested in. ",
  "chats": "Chats",
  "checklist": "Checklist",
  "checklist_added": "Checklist added",
  "checklist_comment_field_text": "Write your comment here",
  "checklist_completed_counter": "Completed",
  "checklist_data_not_saved": "By turning off checklist data you provided will not be saved",
  "checklist_item": "Checklist item",
  "checklist_items_to_add": "Write how many items you would like to add",
  "checklist_not_completed": "Checklist not completed",
  "checklist_status": "Checklist status",
  "checklist_status_delete_error": "Error: Checklist was not deleted",
  "checklist_status_delete_success": "Checklist has been deleted successfully",
  "checklist_status_update_error": "Error: Checklist was not updated",
  "checklist_updated": "Checklist updated",
  "check_your_internet_prefix": "Check your Internet-connection and try again.",
  "choose": "Choose",
  "choose_assets": "Choose assets",
  "choose_building": "Choose building",
  "choose_category": "Choose category",
  "choose_date": "Choose Date",
  "choose_endor": "Choose Vendor",
  "choose_floor": "Choose floor",
  "choose_from_gallery": "Choose from gallery",
  "choose_language": "Choose language",
  "choose_location": "Choose a location",
  "choose_locations": "Choose locations",
  "choose_model_or_load_if_empty": "Choose model or load if here is empty",
  "choose_one": "Choose one",
  "choose_responsible": "Choose responsible",
  "choose_room": "Choose room",
  "choose_room_type": "Choose Room Type",
  "choose_type": "Choose Type",
  "classification": "Classification",
  "classifications": "Classifications",
  "classification_standard": "Classification standard",
  "classification_types_at": "Autility",
  "classification_types_bct": "Building Component Table",
  "classification_types_ccb": "Component Codes",
  "classification_types_ifc": "IFC",
  "classify_files": "Classify files and confirm import to files directory.",
  "classify_files_description": "Classify files and confirm import to files directory",
  "class_text": "Class",
  "clear": "Clear",
  "clear_cache": "Clear Cache",
  "click_floor_to_map_model": "Please click a floor to map to model",
  "click_for_more_assets": "Click on them for see more assets or use checkbox for choose asset as part of zone",
  "click_to_add_asset": "Click the button below to add a new asset",
  "click_to_add_floors": "Click on the button under to add floor to this building",
  "click_to_add_rooms": "Click on Floor plan to start adding rooms",
  "click_to_add_users_description": "Click the button below to add some",
  "click_to_create_incident": "Click the button below to create a new incident",
  "click_to_create_request": "Click to create a request",
  "click_to_move_floor_height": "Click on plane to start moving floor height. Click here to save plain heights.",
  "click_to_place_entity": "Click to place entity {name}",
  "click_to_send_message": "Click on button below to send the message",
  "click_to_upload_files": "Click the button below to upload files",
  "click_to_upload_models": "Click on button below to upload new files",
  "close": "Close",
  "closed": "Closed",
  "close_incident": "Close incident",
  "code": "Code",
  "comfort": "Comfort",
  "comment": "Comment",
  "comment_deleted": "Comment deleted",
  "comment_field_text": "Write your comment here",
  "comments": "Comments",
  "common_room": "Common Room",
  "company": "Company",
  "compass": "Compass",
  "compass_editor_tooltip": "Edit Compass Directions",
  "compass_toolbar_tooltip": "Compass Tool",
  "completed": "Completed",
  "completed_date_not_set": "Date off completion not set",
  "completed_files": "Amount of files completed",
  "complete_request": "Complete request",
  "complete_work_order": "Complete work order",
  "complete_wo_without_checklist": "Complete work order without completing the checklist?",
  "compliance_breach": "Compliance Breach",
  "component_codes": "Component codes",
  "component_created_success": "New component created",
  "component_deleted_success": "Component deleted",
  "component_name_updated": "Name of component updated",
  "condition_assessment": "Condition Assessment",
  "condition_grade": "Condition grade",
  "condition_grade_0": "No defects or symptoms",
  "condition_grade_1": "Minor symptoms or defects",
  "condition_grade_2": "Moderate symptoms or defects",
  "condition_grade_3": "Significant symptoms or defects",
  "condition_grade_analysis": "Condition grade analysis",
  "condition_grade_note": "Condition grade note",
  "condition_grade_not_inspected": "Not inspected",
  "condition_grade_shorthand": "CG",
  "confirm": "Confirm",
  "confirm_action": "Confirm action",
  "confirmation_delete_prefix": "Are you sure you want to delete this ",
  "confirmed": "Confirmed",
  "confirm_installation": "Confirm Installation",
  "connected_to": "Connected to",
  "connect_email_service": "Connect to email service",
  "connect_email_service_now": "Connect to email service now.",
  "consequence_rating": "Consequence Rating",
  "consequence_rating_choices_cr0": "CR0",
  "consequence_rating_choices_cr1": "CR1",
  "consequence_rating_choices_cr2": "CR2",
  "consequence_rating_choices_cr3": "CR3",
  "construction_year": "Year of construction",
  "contact_administrator_for_feature": "Please contact your administrator to enable this feature",
  "contact_administrator_upload_model": "Contact your company administrator to ask upload a 3D building model",
  "contact_created_success": "Contact was added successfully",
  "contacts": "Contacts",
  "contacts_description": "Manage contacts and group them by location, company or label to quickly and easily find contacts",
  "contact_updated_success": "Contact was successfully updated",
  "coordinates_saved": "Coordinates have been saved",
  "copy_of": "Copy of",
  "copy_selection_to_clipboard": "Copy selection to clipboard",
  "copy_to_clipboard": "Copy to clipboard",
  "copy_to_location": "Copy to location",
  "copy_view": "Copy view",
  "cost": "Cost",
  "cost_allocation": "Cost Allocation",
  "cost_allocation_card_subtitle": "Cost allocation related to regulatory deficiencies, immediate measures, and 1-5 year maintenance for the entire property.",
  "cost_allocation_changed": "Cost Allocation is changed",
  "cost_of_repair": "Cost of Repair",
  "cost_of_work": "Cost of Work",
  "could_not_add_contact": "Could not add contact",
  "could_not_add_new_measurement": "Could not add new measurement",
  "could_not_delete_contact": "Could not delete contact",
  "could_not_edit_contact": "Could not edit contact",
  "could_not_load_contacts": "Could not load contacts",
  "could_not_save_file": "Could not save the file",
  "could_not_update_model_path": "Could not update custom model view path.",
  "could_not_upload_image": "Could not upload the image",
  "country_code": "Country code",
  "country_iso": "Country ISO",
  "create": "Create",
  "create_a_new": "Create a new",
  "create_asset": "Create asset",
  "create_a_twin": "Create a Twin",
  "create_building_msg": "The location address cannot be changed after the building has been saved. If you need to change it, please contact support.",
  "create_copies": "Create copies",
  "created": "Created",
  "created_at_date_and_time": "Created on the {date} at {time}  ",
  "created_by": "Created by",
  "created_by_name_and_date": "Created by {name} on the {date} at {time}",
  "created_date": "Created date",
  "create_incident": "Create Incident",
  "create_new_zone": "CREATE NEW ZONE",
  "create_new_zone_msg": "Create zones for easy data tracking and management.",
  "create_new_zone_title": "Want to organize your data?",
  "create_request": "Create Request",
  "create_view": "Create view",
  "create_view_button": "Create View",
  "create_views_description": "Create a new view by clicking on the Create view button and then add page into the view. You can have several views with different topics like Fire Book and Maintenance Plan.",
  "create_work_order": "Create Work Order",
  "create_zone_easy": "Creating a zone is easy!",
  "creation_date": "Creation Date",
  "critical": "Critical",
  "ctrl_enter_to_submit": "Press Ctrl+Enter to submit {type}",
  "current_cache_size": "Current Cache Size",
  "current_user": "Me",
  "custom": "Custom",
  "custom_model_viewer_url": "Costum Model Viewer Path",
  "custom_routine": "Custom routine",
  "custom_routines": "Custom routines",
  "dashboard": "Dashboard",
  "dashboard_tab": "Dashboard",
  "data_delete_warning": "All your data will be lost",
  "data_point_deleted": "Data point deleted",
  "data_point_updated": "Data point updated",
  "date": "Date",
  "day": "Day",
  "days_ago": "Days ago",
  "deadline": "Deadline",
  "december": "December",
  "decline": "Decline",
  "decline_all": "Decline all",
  "default_filter_when_opening_twin": "Default filter when opening Twin",
  "defect": "Defect",
  "deferred_maintenance": "Deferred Maintenance",
  "delete": "Delete",
  "delete_asset": "Delete asset",
  "delete_asset_confirmation": "All your data will be deleted. Are you sure you want to delete this asset?",
  "delete_checklist": "Delete checklist",
  "delete_checklist_confirm": "Are you sure you want to delete this checklist?",
  "delete_comment": "Delete comment",
  "delete_comment_confirmation": "Are you sure you want to delete your comment?",
  "delete_component": "Delete this Component",
  "delete_confirmation": "Are you sure you want to delete {itemType} for <b>{itemName}</b>?",
  "delete_confirmation_plural": "{count, plural, other {Are you sure you want to delete <b># {type}s</b>?} =1 {Are you sure you want to delete <b># {type}</b>?}}",
  "delete_contact": "Delete contact",
  "delete_file_confirmation": "Are you sure you want to delete file <b>{filename}</b>?",
  "delete_files_confirmation": "Are you sure you want to delete {count} {type}?",
  "delete_floor": "Delete floor",
  "delete_floor_confirmation": "Are you sure you want to delete this Floor?",
  "delete_incident": "Delete Incident",
  "delete_incident_confirmation": "All your data will be deleted. Are you sure you want to delete this incident?",
  "delete_items_confirmation": "Are you sure you want to delete <b>{count} {type}</b>?",
  "delete_label": "Delete Label",
  "delete_model": "Delete Model",
  "delete_model_confirmation": "Are you sure you want to delete this Model?",
  "delete_only_local_model": "Delete only visible objects",
  "delete_organization": "Delete Organization",
  "delete_organization_confirmation": "Are you sure you want to delete organization <b>{name}</b>?",
  "delete_page": "Delete page",
  "delete_polygon": "Delete polygon",
  "delete_request": "Delete request",
  "delete_room": "Delete Room",
  "delete_routine_template": "Delete routine template",
  "delete_routine_template_confirm": "Are you sure you want to delete this routine template?",
  "delete_team": "Delete Team",
  "delete_team_confirmation": "Are you sure you want to delete team <b>{name}</b>?",
  "delete_user": "Delete user",
  "delete_user_confirmation": "Are you sure you want to delete user <b>{firstName} {lastName}</b>?",
  "delete_view": "Delete view",
  "delete_views_description": "{count, plural, one {This will also delete all of the pages in the view.} other {This will also delete all of the pages in the views.}}",
  "delete_views_title": "{count, plural, one {Delete # View?} other {Delete # Views?}}",
  "delete_work_order": "Delete work order",
  "delete_work_order_confirm": "Are you sure you want to delete this Work Order?",
  "delete_work_order_confirmation": "All your data will be deleted. Are you sure you want to delete this work order?",
  "delete_work_order_description": "All your data will be lost.",
  "description": "Description",
  "description_of_view": "Description of view",
  "detach_work_order": "Detach Work Order",
  "deviation_type": "Deviation Type",
  "deviation_type_changed": "Deviation Type is changed",
  "dialog_delete_asset_description": "Are you sure you want to delete this Asset?",
  "dialog_delete_asset_title": "Delete Asset",
  "dialog_delete_comment_description": "Are you sure you want to delete this comment?",
  "dialog_delete_comment_title": "Delete comment",
  "dialog_delete_data_loss_warning": "All your data will be lost.",
  "dialog_delete_description": "Are you sure you want to delete this {type}?",
  "dialog_delete_file_description": "Are you sure you want to delete file <b>{name}</b>?",
  "dialog_delete_file_linked_locations_warning": "This file is linked to other locations. If you delete this file,  it will be removed from all locations. <br> <b>Do you want to delete file?</b>",
  "dialog_delete_files_description": "Are you sure you want to delete {count} files?",
  "dialog_delete_file_title": "Delete File",
  "dialog_delete_incident_description": "Are you sure you want to delete this Incident?",
  "dialog_delete_incident_title": "Delete Incident",
  "dialog_delete_model_description": "Are you sure you want to delete this Model?",
  "dialog_delete_model_title": "Delete Model",
  "dialog_delete_multiple_description": "Are you sure you want to delete {count} {type}s?",
  "dialog_delete_page_description": "Are you sure you want to delete the page \"{name}\"?",
  "dialog_delete_page_title": "Delete Page",
  "dialog_delete_request_description": "Are you sure you want to delete this Request?",
  "dialog_delete_request_success": "The request has been deleted ",
  "dialog_delete_request_title": "Delete Request",
  "dialog_delete_room_description": "Are you sure you want to delete this Room?",
  "dialog_delete_room_title": "Delete Room",
  "dialog_delete_session_description": "Are you sure you want to delete \"{name}\"?",
  "dialog_delete_session_title": "Delete Session",
  "dialog_delete_title": "Delete {type}",
  "dialog_delete_view_description": "Are you sure you want to delete the view \"{name}\"?",
  "dialog_delete_view_title": "Delete View",
  "dialog_delete_work_order_description": "Are you sure you want to delete this Work Order?",
  "dialog_delete_work_order_title": "Delete Work Order",
  "digital_twin": "Digital Twin",
  "discard": "Discard",
  "discard_incident": "Discard incident",
  "display": "Display",
  "document_type": "Document type",
  "document_types_contract": "Contract",
  "document_types_drawing": "Drawing",
  "document_types_image": "Image",
  "document_types_manual": "Manual",
  "document_types_no_document_type": "No document type",
  "document_types_regulation": "Regulation",
  "document_types_report": "Report",
  "done": "Done",
  "download": "Download",
  "download_file": "Download file",
  "downloads": "Downloads",
  "drag_drop_assets_zone": "Drag and drop assets to create a zone",
  "drag_drop_files": "Drag and Drop Files here.",
  "drag_drop_photo_text": "Drag and Drop Photo Here\nor Click to Select",
  "drag_drop_sensors_to_room": "Drag and Drop Sensors to connect them to this Room",
  "dropdown_option_none": "None",
  "due_date": "Due date",
  "edit": "Edit",
  "edit_asset": "Edit Asset",
  "edit_checklist": "Edit checklist",
  "edit_classifications": "Edit classifications",
  "edit_component_name": "Edit Name of Component",
  "edit_condition_grade": "Edit condition grade",
  "edit_contact": "Edit contact",
  "edit_description": "Edit description",
  "edit_file": "Edit File",
  "edit_incident": "Edit Incident",
  "editing_room_status": "Editing Room",
  "edit_installation_cost": "Edit cost of installation",
  "edit_location": "Edit Location",
  "edit_location_data": "Edit location",
  "edit_locations": "Edit locations",
  "edit_lock": "Edit lock",
  "edit_lock_warning": "Please edit lock to select a location.",
  "edit_maintenance_settings": "Edit maintenance settings",
  "edit_mode": "Edit Mode",
  "edit_mode_description": "Add or edit rooms, floors, assets and systems.",
  "edit_model": "Edit Model",
  "edit_name": "Edit Name",
  "edit_org": "Edit organization",
  "edit_organization": "Edit Organization",
  "edit_organization_with_name": "Edit Organization \"{name}\"",
  "edit_page": "Edit page",
  "edit_productname": "Edit productname",
  "edit_profile": "Edit Profile",
  "edit_request": "Edit Request",
  "edit_room": "Edit Room",
  "edit_section_title": "Edit Section",
  "edit_serial_number": "Edit serial number",
  "edit_team": "Edit team",
  "edit_team_with_name": "Edit Team {name}",
  "edit_title": "Edit Title",
  "edit_user": "Edit user",
  "edit_view": "Edit view",
  "edit_work_order": "Edit Work Order",
  "edit_zone": "Edit Zone",
  "edit_zone_easy": "Edit a zone is easy!",
  "electrical": "Electrical",
  "email": "Email",
  "email_address": "Email address",
  "email_already_added": "You have already added this email {email}",
  "email_invalid_message": "Please enter a valid email address",
  "email_registered": "Email is registered.",
  "email_service": "Email Service",
  "empty": "Empty",
  "empty_filter": "Empty",
  "empty_inbox": "Good job! You are completely caught up!",
  "empty_incident_description": "To change or empty the filter, please click the filter button. Push \"+\" to add an incident",
  "empty_mail_field_placeholder": "You must enter an email",
  "empty_models": "empty models",
  "empty_password_field_placeholder": "You must enter a password",
  "empty_request_description": "To change or empty the filter, please click the filter button.",
  "energy": "Energy",
  "energy_consumption": "Energy Consumption",
  "energy_usage": "Energy Usage",
  "english": "English",
  "enter_building": "Enter building",
  "enter_building_location": "Enter Location",
  "enter_building_name": "Enter building name",
  "enter_building_square_meters": "Amount of sqm",
  "enter_cost": "Enter Cost",
  "enter_label_name": "Enter Label Name",
  "enter_name": "Enter name",
  "enter_new_floor_name_placeholder": "Enter new floor name",
  "enter_new_value": "Enter a new value",
  "enter_number": "Enter a number",
  "enter_task": "Enter task",
  "enter_title": "Enter Title",
  "enter_unit": "Enter Unit",
  "enter_year_placeholder": "Enter year",
  "entity": "Entity",
  "entity_cannot_be_shown_in_dt": "Entity cannot be shown in Twin. Place entity in Twin",
  "entity_for_page": "Entity for page",
  "entity_type_label": "Entity Type",
  "error": "Error",
  "error_asset_type_not_exist": "This type of asset does not exist",
  "error_comment_delete": "Failed to delete comment. Please try again.",
  "error_comment_save": "Failed to save comment. Please try again.",
  "error_during_email_integration": "Error during email integration",
  "error_fetch_notifications": "Failed to fetch notifications",
  "error_files_confirm": "Could not confirm all files",
  "error_files_delete": "Could not delete files",
  "error_generic_refresh": "Something went wrong. Please refresh and try again",
  "error_generic_try_again": "Something went wrong. Please try again later or report an issue to support",
  "error_height_update": "Height update failed",
  "error_invalid_email": "Invalid email address",
  "error_message_default_message": "Something went wrong. Please try again later or report the issue to support",
  "error_model_operation": "Something went wrong with model operation",
  "error_model_update": "Model update failed",
  "error_object_not_exist": "Object does not exist",
  "error_only_zip_files": "Only zip files are allowed",
  "error_room_has_sensors": "This room contains sensors. Please delete them first",
  "error_room_type_change": "Could not change the room type",
  "error_save_planes": "Failed to save planes",
  "error_session_delete": "Failed to delete session",
  "error_session_rename": "Failed to rename session",
  "error_transformations_save": "Transformations saving failed",
  "error_updating_building_image": "Error updating building image",
  "error_updating_location": "There was an error updating your location",
  "every": "Every",
  "excel": "Excel",
  "excellent": "Excellent",
  "exclude_weekends": "Exclude weekends",
  "existing_asset": "Existing Assets",
  "existing_entities": "Existing Entities",
  "existing_file": "Existing File",
  "existing_floors_and_rooms": "Existing floors and rooms in the building.",
  "existing_incident": "Existing incident",
  "existing_models_in_building": "Existing models in building",
  "exit_edit_mode": "Exit edit mode?",
  "experiment_new_right_sidebar": "New right sidebar *Unstable (only for work orders)",
  "experiment_nrs_description": "Enable new right sidebar workspace for cmms entities",
  "experiments": "Experiments",
  "experiments_msg": "Active beta versions of new functionality. When activated you will be able to test\n\t\t\tthe new functions in the web version.",
  "experiments_section_ai_asset_description": "Enables AI-powered analysis of asset images to suggest names, descriptions, and other details",
  "experiments_section_ai_asset_title": "AI Asset Image Analysis",
  "experiments_section_asr_description": "Enable voice input in AI chat using automatic speech recognition",
  "experiments_section_asr_title": "Voice input for AI chat",
  "experiments_section_contrast_description": "Enable contrast background for Digital Twin scene",
  "experiments_section_contrast_title": "Contrast background for Twin scene",
  "experiments_section_create_twin_description": "Enable the step by step process to configure the Twin",
  "experiments_section_create_twin_title": "New Create Twin process",
  "experiments_section_culling_description": "When enabled, elements not in the view will be hidden",
  "experiments_section_culling_title": "Culling",
  "experiments_section_enable_matterport_description": "Integrate Matterport scans for Assets",
  "experiments_section_enable_matterport_title": "Connect Matterport",
  "experiments_section_glb_description": "Disable GLB optimisation for Digital Twin scans",
  "experiments_section_glb_title": "Disable GLB optimisation",
  "experiments_section_grouping_description": "When enabled, elements close to each other in the Twin will be grouped",
  "experiments_section_grouping_title": "Grouping in Twin",
  "experiments_section_hyper_performance_description": "Performance mode loads your 3D model faster by displaying only the important elements.",
  "experiments_section_hyper_performance_title": "Enable Advance Performance",
  "experiments_section_ifc_description": "Enable tile-based rendering for IFC models to improve performance and loading times",
  "experiments_section_ifc_title": "Enable IFC model optimization",
  "experiments_section_language_description": "Enable language selector located in edit profile",
  "experiments_section_language_title": "Change language",
  "experiments_section_layers_panel_description": "Enable the new layers panel for model selection and tools in the Twin",
  "experiments_section_layers_panel_title": "New Layers panel in Twin",
  "experiments_section_list_view_description": "Activate list view option for assets.",
  "experiments_section_list_view_title": "Entity list view",
  "experiments_section_reports_menu_description": "Enables reports for buildings you have added to ‘My Buildings’, where you can find the condition grade analysis of each building.",
  "experiments_section_reports_menu_title": "Reports",
  "experiments_section_rerank_description": "Reranking improves search relevance in AI chat by reordering results for better context and accuracy",
  "experiments_section_rerank_title": "Toggle between rerank for AI chat",
  "export": "Export",
  "export_page": "Export page",
  "export_pdf": "Export to PDF",
  "export_with_measurements": "Export with measurements",
  "export_without_measurements": "Export without measurements",
  "extracting_and_analyzing_status": "Extracting & Analyzing",
  "facility_manager": "Facility Manager",
  "failed": "Failed",
  "failed_add_value": "Failed to add new value",
  "failed_create_component": "Failed to create component",
  "failed_delete_component": "Failed to delete component",
  "failed_delete_routine_template": "Failed to delete routine template",
  "failed_set_units": "Failed to set units",
  "failed_to_delete_data_point": "Failed to delete data point",
  "failed_to_fetch": "Could not fetch",
  "failed_to_fetch_buildings": "Failed to fetch buildings",
  "failed_to_fetch_data": "Could not fetch the data, try again later",
  "failed_to_generate_export_link": "Failed to generate export link",
  "failed_to_get_models": "Failed to get models",
  "failed_to_load_model": "Failed to load this model",
  "failed_to_load_models": "Failed to load models",
  "failed_to_process_location": "Failed to process location",
  "failed_to_save": "Failed to save",
  "failed_to_save_settings": "Failed to save settings",
  "failed_to_unlink": "Something went wrong while unlinking, please try again or contact support.",
  "failed_to_update_data_point": "Failed to update data point",
  "failed_to_update_notification_settings": "Failed to update notification settings",
  "failed_update_component_name": "Failed to update component name",
  "fair": "Fair",
  "favourited_models_twin_startup": "Favourited models will show in twin on startup. Change this in the model section of the building configuration",
  "feature": "Feature",
  "february": "February",
  "fetching_models": "Fetching models",
  "fetching_more_information": "Fetching more information ...",
  "file": "File",
  "file_deleted": "The file has been deleted",
  "file_detector": "File Detector",
  "file_id": "File ID",
  "file_import": "File Import",
  "file_import_desc": "Location is mandatory and must be selected for all files. We recommend that you classify and set the document type on the files. When you are finished, confirm the import of the files so that the files are available for operation.",
  "files": "Files",
  "files_confirm_import": "Confirmed imported files:",
  "files_for": "files for",
  "files_import_all_set": "You're all set!",
  "files_import_analysis_failed": "Analysis failed",
  "files_import_analyzing": "Analyzing",
  "files_import_check_files": "Please double check that valid files are uploaded.",
  "files_import_completed": "Completed file imports",
  "files_import_confirmed": "Files Import Confirmed",
  "files_import_enjoy": "Enjoy your organized files.",
  "files_import_extracting": "Extracting",
  "files_import_extraction_failed": "Extraction failed",
  "files_import_go_back": "Go back to import",
  "files_import_imported_files": "Imported Files",
  "files_import_no_files": "No files found",
  "files_import_ongoing_work": "Ongoing work",
  "files_import_see_files": "See your files",
  "files_import_step_one": "Import Files",
  "files_import_step_three": "Enjoy Organized Files in your Operations",
  "files_import_step_two": "Organize Files",
  "files_import_title": "Files Import",
  "files_import_to_confirm": "Files to confirm and import",
  "files_import_uploading": "Uploading files",
  "files_import_uploading_warning": "Please don't refresh page until loaded",
  "files_section_cant_delete_file": "Can't delete file. Something went wrong",
  "files_section_classification": "Classification",
  "files_section_delete_file_confirmation": "Are you sure you want to delete file <b>{name}</b>?",
  "files_section_delete_files_confirmation": "{length, plural, other {Are you sure you want to delete # files?} =1 {Are you sure you want to delete # file?}}",
  "files_section_document_type": "Document Type",
  "files_section_file_count": "{count, plural, one {# file} other {# files} =0 {No files}}",
  "files_section_file_deleted": "{count, plural, one {# file deleted} other {# files deleted} =0 {No files deleted}}",
  "files_section_file_delete_error": "Error deleting file",
  "files_section_file_selected": "{count, plural, one {# file selected} other {# files selected} =0 {No files selected}}",
  "files_section_file_uploaded": "{count, plural, one {# file uploaded} other {# files uploaded} =0 {No files uploaded}}",
  "files_section_file_upload_error": "Error uploading file",
  "files_section_file_validation_error": "File validation error",
  "files_section_wait_file_loaded": "Please wait while the file is loaded",
  "files_selected": "{count, plural, other {Files Selected} =1 {File Selected}}",
  "files_successfully_uploaded": "Files was successfully uploaded",
  "filetype": "Filetype",
  "file_viewer_cant_show_file": "Can't show this file",
  "file_viewer_click_to_download": "Click here to download the file",
  "file_viewer_dwg_not_supported": "Viewing of DWG file is not supported",
  "file_viewer_file_not_available": "For some reason the file is not available",
  "file_viewer_type_not_supported": "We can't show this type of file",
  "file_viewer_video_not_supported": "Your browser does not support the video tag",
  "filter": "Filter",
  "filter_by_name": "Filter by name",
  "filters_all_selected": "All filter options selected",
  "filters_filter_by": "Filter by…",
  "filters_no_results": "No Results",
  "fire": "Fire",
  "first_name": "First name",
  "first_person_view": "First Person view mode",
  "five_to_ten_years": "5 - 10 years",
  "floor": "Floor",
  "floor_connected_to_model": "Floor connected to this model",
  "floor_default_name": "Floor {floorNumber}",
  "floor_delete_error_has_rooms": "This floor contains rooms. Please delete them first",
  "floor_delete_success": "Floor has been deleted successfully",
  "floor_explosion": "Floor Explosion",
  "floor_name_changed": "You've changed floor name",
  "floor_name_label": "Floor Name",
  "floor_plans": "Floor plans",
  "floor_rename_success": "Floor has been renamed successfully",
  "floors": "Floors",
  "floors_loading": "Floors information loading",
  "fm_org_id": "FM Organization ID",
  "folder_edited_success": "Folder has been edited successfully",
  "folder_views_title": "Folder Views",
  "forgot_password": "Forgot Password?",
  "format": "Format",
  "friday": "Friday",
  "from": "From",
  "full_date": "Full Date",
  "fullscreen": "Fullscreen",
  "general": "General",
  "general_info": "General info",
  "generating_prefill": "Generating new entity",
  "generating_prefill_info": "Wait while we are filling out an entity for you",
  "generating_status": "Generating",
  "generic": "Generic",
  "get_in_touch": "Get in touch with us",
  "get_in_touch_link_msg": "Get in touch with us",
  "get_in_touch_msg": "to find out how we can get you up and running!",
  "get_pdf": "Get PDF",
  "good": "Good",
  "go_to": "Go to",
  "go_to_models_tab_map": "Go to the models tab to map the floor",
  "group_completed": "Completed",
  "grouped_by": "Grouped by",
  "group_sensor_list_msg": "List of installed sensors for this group:",
  "hallway": "Hallway",
  "has_been_created_successfully": "has been created successfully",
  "has_been_deleted": "Has been deleted",
  "has_been_deleted_successfully": "has been deleted successfully",
  "has_been_replaced_successfully": "has been replaced successfully",
  "has_been_updated_successfully": "has been updated successfully",
  "heating_and_cooling": "Heating and cooling",
  "hide": "Hide",
  "hide_filters": "Hide filters",
  "high": "High",
  "hi_there": "Hi there!",
  "hour": "Hour",
  "hours_ago": "Hours ago",
  "how_many_floors_in": "How many floors in",
  "id": "ID",
  "images": "Images",
  "immediate": "Immediate",
  "immediate_action": "Immediate action",
  "immediate_column": "Other immediate measures",
  "import": "Import",
  "inbox": "Inbox",
  "inbox_header": "Inbox (beta)",
  "inbox_notifications_button_show_read": "Show read notifications",
  "inbox_notifications_no_more_msg": "That's all your notifications from the last 30 days.",
  "incident": "Incident",
  "incident_attached": "Incident attached",
  "incident_has_been_unlinked": "Incident has been unlinked",
  "incident_id": "Incident ID",
  "incident_name_edited": "The incident name has been edited",
  "incident_name_required": "Incident name must be entered",
  "incident_number": "Incident number",
  "incident_registered_closed": "Incident registered as closed",
  "incidents": "Incidents",
  "incidents_has_been_unlinked": "{count, plural, one {Incident was unlinked} other {Incidents were unlinked}}",
  "incident_unlinked": "Incident has been unlinked",
  "incorrect_value": "Incorrect value",
  "indoor_climate": "Indoor Climate",
  "info": "Info",
  "information": "Information",
  "in_management": "In management",
  "in_progress": "In progress",
  "in_review": "In Review",
  "installation": "Installation",
  "installation_cost": "Installation cost",
  "installation_date": "Installation date",
  "installed_sensors": "Installed Sensors",
  "installed_sensors_list": "List of installed sensors for this group:",
  "integrate_with_azure_first": "Integrate with Azure first.",
  "internal_comment": "Type your internal comment",
  "internal_comment_msg": "Type your internal comment",
  "invalid": "Invalid",
  "invalid_building_address": "Invalid building address",
  "invalid_code": "Invalid code",
  "invalid_email": "Invalid email",
  "invalid_email_address": "Invalid email address",
  "invalid_email_password": "Invalid email or password",
  "invalid_email_placeholder": "Invalid e-mail",
  "invalid_phone_number": "Invalid phone number",
  "invalid_workspace_type": "Invalid workspace type",
  "items_per_page": "Items per page:",
  "january": "January",
  "july": "July",
  "june": "June",
  "kitchen": "Kitchen",
  "label": "Label",
  "label_delete_warning": "Label you want to delete is <strong>used {count} times</strong>. </br>Proceed anyway?",
  "labels": "Labels",
  "labels_list": "{count, plural, one {Label} other {Labels}}",
  "language": "Language",
  "last_checked": "Last checked",
  "last_data": "Last Data",
  "last_month": "Last Month",
  "last_name": "Last name",
  "last_updated": "Last updated",
  "lastweek": "Last week",
  "last_year": "Last Year",
  "layers": "Layers",
  "leave_comment_here": "Leave a comment here",
  "leave_reply_here": "Leave a reply here",
  "link_incident": "Link incident",
  "links": "Links",
  "list": "List",
  "list_view": "List view",
  "list_view_is_disabled": "List view is disabled",
  "loaded_models": "Loaded models",
  "loading_at_start": "Loading at start",
  "loading_data_placeholder": "We are loading your data",
  "loading_dialog_status": "Loading",
  "loading_incidents": "Loading incidents",
  "loading_models": "Loading models",
  "loading_models_status": "Loading models",
  "location": "Location",
  "location_address": "Location address",
  "location_name": "Location name",
  "locations": "Locations",
  "location_updated": "Your location has successfully been updated",
  "lock_info": "Lock Info",
  "lock_name": "Lock Name",
  "locks": "Locks",
  "locks_admin_org_name": "Locks Administrator Organization Name",
  "log_in": "Log In",
  "log_in_msg": "Login to Your Account",
  "login_to_account": "Login to your account",
  "log_out": "Log Out",
  "loose_populated_data": "You will loose all populated data. Proceed anyway?",
  "low": "Low",
  "lower": "Lower",
  "maintenance": "Maintenance",
  "maintenance_building": "Building",
  "maintenance_card_subtitle": "Maintenance needs related to regulatory deficiencies, immediate measures, and 1-5 year maintenance for the entire property.",
  "maintenance_five_to_ten_years": "Maintenance 5-10 years",
  "maintenance_needs": "Maintenance needs",
  "maintenance_one_to_five_years": "Maintenance 1-5 years",
  "maintenance_piping": "Piping",
  "make_copy": "Make a copy",
  "manage": "Manage",
  "management": "Management",
  "management_type_msg": "Management - building where the app is used for operations and management",
  "manage_models": "Manage models",
  "manage_notifications_description": "Manage here which notifications you want to receive.",
  "manage_workspace_labels_description": "Manage workspace labels. Use labels to help organize and filter entities. Labels created in this section are available for all of your buildings",
  "manufacturer": "Manufacturer",
  "map": "Map",
  "map_floors": "Map floors",
  "map_floors_description": "Map the floorplans to floors",
  "march": "March",
  "mark_all_as_completed": "Mark all as completed",
  "mark_all_as_read": "Mark all as read",
  "mark_all_completed": "Mark all as completed",
  "matterport_share_link": "Add Matterport URL",
  "max_allowed": "Max allowed",
  "max_prefix": "Max",
  "may": "May",
  "me": "Me",
  "measurements": "Measurements",
  "measurements_name": "Name",
  "measurements_unit": "Unit",
  "measurements_unit_hint": "Enter unit",
  "medium": "Medium",
  "meeting_room": "Meeting Room",
  "menu_delete_option": "Delete",
  "message": "Message",
  "message_is_sent": "Message is sent",
  "messages": "Messages",
  "milestone_removed": "Milestone was removed",
  "milestones": "Milestones",
  "minute": "Minute",
  "minutes": "Minutes",
  "missing_email_addresses": "{count} contacts in the selected group are missing email addresses and will not receive this message",
  "missing_fields_create_new": "Missing required fields: {fields}",
  "missing_location_or_building_data": "Missing location or building data",
  "mixed": "Mixed",
  "model_alignment": "Model Alignment",
  "model_cache": "Model Cache",
  "model_delete_error": "Model deletion failed",
  "model_delete_success": "Model deleted successfully",
  "model_loading_at_start_changed": "Model {name} set to {state, select, true{not} other{}} loading at start",
  "model_marked_as_favorite": "Model {name} marked as favorite",
  "model_not_mapped_to_locations": "Model not mapped to Locations",
  "models": "Models",
  "model_settings_change_failed": "Failed to change model settings, something went wrong",
  "model_settings_change_failed_multiple": "Failed to change settings for {count} models",
  "models_marked_as_favorite": "{count} models marked as favorite",
  "models_unmarked_as_favorite": "{count} models removed from favorites",
  "model_type_3d_scans": "3D-scans",
  "model_type_bim": "BIM",
  "model_type_floor_plans": "Floor plans",
  "model_unmarked_as_favorite": "Model {name} removed from favorites",
  "model_update_error": "Model update failed",
  "model_upload_success": "Model uploaded successfully",
  "model_viewer": "Model Viewer",
  "model_viewer_placeholder": "MobXXXX",
  "monday": "Monday",
  "month": "Month",
  "months": "Months",
  "more": "more",
  "more_information": "More Information",
  "move": "Move",
  "my_buildings": "My Buildings",
  "my_settings": "My Settings",
  "name": "Name",
  "name_of_page_placeholder": "Name of page",
  "name_of_view": "Name of view",
  "name_the_floors": "Name the floors",
  "needed": "Needed",
  "needs_to_be_like": "Needs to be like",
  "new_asset": "New Asset",
  "new_entity": "New entity",
  "new_file": "New File",
  "new_incident": "New Incident",
  "new_label": "New Label",
  "new_page_in_view": "New page in view",
  "new_request": "New Request",
  "new_routine_template": "New routine template",
  "new_status": "New",
  "new_text": "New",
  "new_timeseries_label": "New Timeseries",
  "new_view": "New View",
  "new_work_order": "New Work Order",
  "new_zone_and_zensor_count": "And {count}",
  "next": "Next",
  "next_month": "Next Month",
  "next_week": "Next week",
  "next_year": "Next Year",
  "no": "No",
  "no_access_energy_warning": "It seems we don't have access to your energy data yet.",
  "no_address": "No address",
  "no_assets": "No assets",
  "no_building_found_for_floor": "No building found for floor",
  "no_building_found_for_location": "No building found for location",
  "no_building_found_for_room": "No building found for room",
  "no_building_id_or_entity_id": "No building ID or entity ID found",
  "no_buildings": "No buildings",
  "no_buildings_description": "There are no buildings to show",
  "no_buildings_to_show": "There are no buildings to show",
  "no_classification": "No classification",
  "no_data": "No data",
  "no_data_available": "No data available",
  "no_data_detailed_view_warning": "There is no available data for detailed view in here.",
  "no_data_period_message": "It looks like we haven't received data for this period",
  "no_data_period_warning": "It looks like we haven't received data for this period.",
  "no_data_sensor_groups_warning": "There are no sensor groups to show.",
  "no_default_filter": "No default filter",
  "no_detailed_view_data": "There is no available data for detailed view in here",
  "no_document_type": "No document type",
  "no_due_date": "No due date",
  "no_entities_available": "No entities available to open in Digital Twin",
  "no_entities_to_show": "There are no {type} to show",
  "no_files_found": "No files found",
  "no_files_found_description": "There are no models available in this category",
  "no_floors_available": "No floors available. Add some",
  "no_floors_in_building": "No floors in this building",
  "no_image": "No image",
  "no_incidents_warning": "There are no incidents to show",
  "no_items_to_show": "There are no {type} to Show",
  "no_location": "No location",
  "no_location_found": "No location found",
  "no_model_for_building_warning": "There is no 3d model for this building",
  "no_models_found_for_building": "No models found for this building",
  "no_models_in_twin_set_up": "No models in the Twin are set up for this model type. To upload and set up models, use the building configuration",
  "no_models_to_view": "No models to view",
  "no_name": "No Name",
  "none": "None",
  "none_selected": "None",
  "no_notifications_warning": "There are no notifications yet",
  "no_options_available": "No options available",
  "no_permissions": "There are no permissions",
  "no_permissions_msg": "There are no permissions.",
  "no_permissions_placeholder": "There are no permissions",
  "no_phone_number": "No phone number",
  "no_results_found": "No results found",
  "normal": "Normal",
  "no_rooms_found": "No rooms found",
  "no_rooms_on_floor": "There are no rooms on this floor",
  "no_rooms_warning": "There are no rooms to show.",
  "norwegian": "Norwegian",
  "norwegian_currency": "NOK",
  "no_sensor_groups": "There are no sensor groups to show",
  "no_sensors": "No sensors",
  "no_sensors_available": "No sensors available",
  "no_sensors_found": "No sensors found",
  "no_sensors_in_building": "There are no sensors installed in this building yet",
  "no_sensors_in_room": "No sensors in this room",
  "no_sensors_registered": "There are no sensors registered",
  "no_sensors_selected": "No sensors selected",
  "no_sensors_to_show": "There are no sensors to show",
  "no_signal": "No signal yet",
  "no_status": "No Status",
  "not_assigned": "Not assigned",
  "not_classified": "Not classified",
  "no_teams_in_org": "No teams in organization",
  "no_teams_in_organization": "No teams in organization",
  "no_templates_found": "No templates match these filters",
  "no_tenants_warning": "There are no tenants to show",
  "notes": "Notes",
  "nothing_here_yet": "Nothing here yet",
  "notifications": "Notifications",
  "notifications_settings_updated": "Notifications settings updated",
  "notify_via_email_description": "Notify via email about important changes",
  "not_inspected": "Not inspected",
  "not_linked": "Not linked",
  "no_tracked_rooms": "There are no tracked rooms to show",
  "not_running": "Not Running",
  "no_type": "No Type",
  "no_users": "No users",
  "no_users_to_show": "There are no Users to Show",
  "no_valid_entities_for_dt": "No valid entities for Digital Twin",
  "november": "November",
  "now": "Now",
  "no_work_orders_date": "There is no Work Order for this date",
  "no_work_order_to_attach": "There are no work orders to attach",
  "no_zones_created": "There are no zones created",
  "number_of_locations": "Number of locations",
  "num_of_floor_to_add": "How many floors you want to add",
  "num_of_hours_ago": "{hours} hours ago",
  "num_of_minutes_ago": "{minutes, plural, one {# minute ago} other {# minutes ago}}",
  "occurred_at": "Occurred at",
  "occurred_at_clock": "Occurred at:",
  "occurred_date": "Occurred Date",
  "october": "October",
  "off": "Off",
  "office": "Office",
  "offline": "Offline",
  "of_text": "of",
  "ok": "Ok",
  "on": "On",
  "one_to_five_years": "1 - 5 years",
  "online": "Online",
  "on_the": "on the ",
  "oops": "Ooops",
  "open": "Open",
  "open_digital_twin": "Open Digital Twin",
  "open_incidents": "{value, plural, one {Open incident} other {Open incidents}}",
  "open_in_dt_button": "Open in Twin",
  "open_in_fullscreen": "Open in fullscreen",
  "open_in_native_app": "Open in native app",
  "open_in_new_tab": "Open in new tab",
  "open_model": "Open model",
  "open_requests": "{value, plural, one {Open request} other {Open requests}}",
  "operations": "Operations",
  "org_about_description": "General information about your organization",
  "organization": "Organization",
  "organization_deleted_success": "Organization was deleted successfully",
  "organization_info": "Organization Info",
  "organization_labels": "Organization Labels",
  "organize_tasks": "Organize tasks",
  "organize_zone_data_description": "Organize your zone data for easy management and tracking",
  "organize_zone_data_title": "Organize Zone Data",
  "other": "Other",
  "other_locations": "Other locations",
  "outdoor": "Outdoor",
  "overdue": "Overdue",
  "owner": "Owner",
  "page_create_success": "Page has been created successfully",
  "page_edit_success": "Page has been edited successfully",
  "parameters": "Parameters",
  "password": "Password",
  "performance_mode_tooltip": "Performance Mode",
  "period": "Period",
  "periods_common_first_day_of_month": "First day of the month",
  "periods_common_last_day_of_month": "Last day of the month",
  "permissions_admin_team": "Permissions for administrators team",
  "permissions_for_administrators": "Permissions for Administrators Team",
  "phone": "Phone",
  "phone_number_eight_digits": "Phone number must be 8 digits",
  "phone_number_only_digits": "Phone number can only contain numbers",
  "photo_upload_disabled": "Photo upload disabled in the short term",
  "pick_day": "Pick day",
  "pick_day_month": "Pick day in month",
  "pick_one": "Pick one",
  "piping": "Piping",
  "placeholder_operations_search_bar": "Quick search by title",
  "place_in_twin": "Place in Twin",
  "planned": "Planned",
  "planned_installation": "Planned Installation",
  "planned_maintenance": "Planned maintenance",
  "please_choose_floor": "Please choose a floor:",
  "please_choose_manufacturer": "Please choose a manufacturer:",
  "please_choose_room": "Please choose a room:",
  "please_choose_type": "Please choose a type:",
  "please_enter_correct_email": "Please enter correct email",
  "please_enter_email_password_reset": "Please enter your email address to reset your password",
  "please_enter_incident_name": "Please enter the incident name",
  "please_enter_required_data": "Please fill in all required data",
  "please_enter_title": "Please enter a title",
  "please_enter_valid_value": "Please enter a valid value",
  "please_fill_required_data": "Please fill required data",
  "please_wait": "Please wait.",
  "please_wait_placeholder": "Please wait. We are loading you data",
  "policy_privacy_confirmation": "I confirm that I have read, consent and agree to the ",
  "poor": "Poor",
  "portfolio": "Portfolio",
  "predictive_maintenance": "Predictive Maintenance",
  "predictive_maintenance_not_configured": "This system is not configured for predictive maintenance yet",
  "predictive_maintenance_warning": "This system is not configured for predictive maintenance yet.",
  "priority": "Priority",
  "privacy_policy": "Privacy Policy",
  "privacy_policy_msg": "We are committed to respect and protect your privacy ",
  "proceed_confirm": "Are you sure you want to proceed?",
  "product_name": "Product name",
  "product_year": "Product year",
  "profile": "Profile",
  "profile_info": "Profile Info",
  "profile_updated_success": "Your profile was successfully updated",
  "project": "Project",
  "project_type_msg": "Project - the app is used for projects in construction, e.g. energy mapping",
  "property_manager": "Property Manager",
  "qty_of_assets": "Qty of Assets",
  "qty_of_floors": "Qty of Floors",
  "qty_of_rooms": "Qty of Rooms",
  "qty_of_sensors": "Qty of Sensors",
  "quick_search": "Quick Search",
  "quick_search_by_name": "Quick Search by Name",
  "quick_search_by_name_or_id": "Quick Search by Name or ID",
  "quick_search_user": "Quick Search User",
  "recipients": "Recipients",
  "reconnect_email_service": "Reconnect with email service",
  "recurring": "Recurring",
  "refresh_token_permissions": "Refresh token and permissions",
  "rejected": "Rejected",
  "related": "Related",
  "related_files": "Related files",
  "remember_me": "Remember me",
  "remember_to_add_at": "Remember to add @",
  "remember_use_valid_chars": "Remember to use valid characters",
  "remove_incident": "Remove incident",
  "remove_link": "Remove link",
  "remove_link_description": "Removing linking, does not delete element",
  "rename": "Rename",
  "repeat": "Repeat",
  "repeat_daily": "Daily",
  "repeat_every": "Repeat each",
  "repeat_monthly": "Monthly",
  "repeat_on": "Repeat On",
  "repeat_password": "Repeat Password",
  "repeat_weekly": "Weekly",
  "replace": "Replace",
  "reply": "Reply",
  "reply_requester": "Type your reply to requester",
  "reply_to": "Reply to",
  "reports": "Reports",
  "report_view_details": "report view details",
  "request": "Request",
  "request_category_updated": "Request Category has been updated",
  "requester": "Requester",
  "request_id": "Request ID",
  "requests": "Requests",
  "requests_header": "Requests (beta)",
  "required": "Required",
  "required_fields_warning": "Please fill in all the required data",
  "reset_password": "Reset password",
  "response_time": "Avg. Response Time",
  "responsible": "Responsible",
  "retry_loading": "Retry loading",
  "right_now": "Right now",
  "risk": "Risk",
  "room": "Room",
  "room_delete_success": "Room has been deleted successfully",
  "room_info": "Room Info",
  "room_name": "Room Name",
  "room_name_placeholder": "Enter Room Name",
  "rooms": "Rooms",
  "room_type": "Room Type",
  "rotate": "Rotate",
  "routine": "Routine",
  "routines": "Routines",
  "routine_template_deleted": "Routine template deleted succesfully",
  "running": "Running",
  "safety": "Safety",
  "sanitary": "Sanitary",
  "saturday": "Saturday",
  "save": "Save",
  "save_changes": "Save changes",
  "save_compass_offset_dialog_create_success": "Compass Directions Saved",
  "saved": "Saved",
  "save_transformation": "Save transformation",
  "save_url": "Save URL",
  "saving": "Saving",
  "scale": "Scale",
  "schedule": "Schedule",
  "search": "Search",
  "search_button_label": "Search",
  "search_filter": "SEARCH",
  "search_or_email": "Search for contact or write email address",
  "search_results": "Search Results",
  "search_sensor": "Search Sensor",
  "search_user": "Search user",
  "search_user_or_team": "Search user or team",
  "search_views_and_pages": "Search for views and pages",
  "select": "Select",
  "select_all": "Select all",
  "select_all_files_confirmation": "Are you sure you want to select all {count} files?",
  "select_all_files_description": "Selecting all files will apply actions to every file in the current view",
  "select_at_least_one_asset": "You must select at least one asset",
  "select_building_for_twin": "Select building for twin",
  "select_date": "Select date",
  "selected": "Selected",
  "select_fields_to_copy": "Select Fields to Copy",
  "select_fields_to_copy_description": "Select which fields you want to copy to the new location",
  "select_filter": "Select Filter",
  "select_granularity": "Select period size",
  "select_items_desktop": "Just select the items from Assets and drag and drop them to the area below",
  "select_items_mobile": "Just select the items from Assets",
  "select_location_before_upload": "Before uploading your file, please choose a location",
  "select_models_here": "Select models here",
  "select_month": "Please select a month",
  "select_option": "Select an option",
  "select_sensor_function": "Select the sensor function",
  "select_year": "Select year",
  "send": "Send",
  "send_message": "Send message",
  "send_new": "Send new",
  "send_reset_password_email": "Send reset password email",
  "sensor_function": "Sensor Function",
  "sensor_functions": "Sensor Functions",
  "sensor_info": "Sensor Info",
  "sensor_installation_confirm_action": "Are you sure you want to proceed without confirming the installation?",
  "sensor_installation_confirm_checkbox": "Confirm installation",
  "sensor_installation_error": "Failed to save",
  "sensor_installation_image_type_validation": "Only images of type '.jpg' are allowed",
  "sensor_installation_no_signal": "No signal yet",
  "sensor_installation_photo_upload_disabled": "Photo upload disabled in the short term",
  "sensor_installation_success": "Sensor installation was saved",
  "sensor_name": "Sensor Name",
  "sensor_name_placeholder": "ex. UM-H1-V1-IV-inntak",
  "sensors": "Sensors",
  "sensor_success_message": "Sensor was successfully added",
  "sensor_type": "Sensor Type",
  "sent_date": "Sent Date",
  "september": "September",
  "serial_number": "Serial Number",
  "serial_number_placeholder": "ex. 123456789",
  "serial_number_short": "S/N",
  "service": "Service",
  "set_due_date": "Set Due Date",
  "set_location": "Set location",
  "set_password": "Set Password",
  "set_password_title": "Please set your password",
  "set_requester_to_enable_reply": "Set requester to enable reply button",
  "settings": "Settings",
  "settings_saved": "Settings saved",
  "share": "Share",
  "shared_link": "Shared link",
  "show": "Show",
  "show_description": "Show full description",
  "show_in_digital_twin": "Show in Digital Twin",
  "show_in_twin": "Show in twin",
  "show_less": "Show less",
  "show_less_comments": "Show less comments",
  "show_less_description": "Show less description",
  "show_less_locations": "Show less locations",
  "show_more": "Show more",
  "show_more_assignees": "Assignee(s)",
  "show_more_buildings": "Building(s)",
  "showmorebuildings": "Building",
  "show_more_comments": "Show more comments",
  "show_read_notifications": "Show read notifications",
  "sidebar_close_window": "Closing the Window",
  "sidebar_close_window_warning": "Closing the window you will lose <strong>all populated data</strong>.</br>Proceed anyway?",
  "sidebar_options": "Sidebar Options",
  "sidebar_title": "Sidebar",
  "signal_strength": "Signal Strength",
  "signature_included_in_email": "Signature is included in the email",
  "something_went_wrong": "Woops! Something went wrong",
  "something_went_wrong_files_prefix": "We are sorry, but something went wrong when uploading your files",
  "sort": "Sort",
  "sort_by": "Sort by",
  "spaces": "Spaces",
  "spaces_only_restricted": "Spaces only is restricted",
  "standard_routine": "Standard routine",
  "standard_routines": "Standard routines",
  "start_new_chat": "Start a new chat",
  "start_typing": "Start typing",
  "start_typing_to_search": "Start typing to search",
  "status": "Status",
  "status_completed": "Completed",
  "status_in_progress": "In progress",
  "status_todo": "Not started",
  "status_updated": "Status have been updated",
  "step": "Step",
  "step_x_of_y": "step {x} of {y}",
  "storage": "Storage",
  "subject": "Subject",
  "submit": "Submit",
  "submit_copy": "Submit copy",
  "submitted": "Submitted",
  "success_asset_create": "Asset has been created successfully",
  "success_assets_delete": "Assets have been deleted successfully",
  "success_auto_tagging": "Auto-tagging completed successfully",
  "success_comment_delete": "Comment deleted successfully",
  "success_comment_save": "Comment saved successfully",
  "success_files_confirm": "All files successfully confirmed",
  "success_floors_height_update": "Floors height successfully updated",
  "success_message_sent": "Message is sent",
  "success_model_delete": "Model has been deleted successfully",
  "success_notifications_caught_up": "Good job! You are completely caught up!",
  "success_password_set_login": "Congratulations! Now you could login with your credentials",
  "success_room_type_change": "Successfully changed room type to {type}",
  "success_sensor_installation_confirm": "Sensor installation confirmed successfully",
  "success_sensor_relocation": "Sensor was successfully relocated",
  "success_session_delete": "Session deleted successfully",
  "success_session_rename": "Session renamed successfully",
  "success_transformations_save": "Transformations saved",
  "sum": "Sum",
  "sum_cost": "Sum cost",
  "summarized_request": "Summarized request",
  "summary": "Summary",
  "sunday": "Sunday",
  "super_admin": "Super Admin",
  "supported_file_formats_title": "Supported file formats",
  "system_state": "System State",
  "table": "Table",
  "take_by_camera": "Take by camera",
  "target": "Target",
  "task_registered_completed": "Task registered as completed",
  "tasks": "Tasks",
  "tasks_completed": "Tasks Completed",
  "team": "Team",
  "team_add_to_org_with_title": "Add New Team to {organizationName}",
  "team_created_success": "Team was added successfully",
  "team_deleted_success": "Team was deleted successfully",
  "team_info": "Team Information",
  "team_permissions": "Permissions for Team",
  "teams": "Teams",
  "team_updated_success": "Team was edited successfully",
  "team_with_name": "Team \"{name}\"",
  "technical_status": "Technical Status",
  "tech_status": "Tech.Status",
  "temperature_or_humidity": "Temperature / Humidity",
  "tenant": "Tenant",
  "tenant_name": "Tenant Name",
  "tenants": "Tenants",
  "text": "Text",
  "this_file": "This file",
  "this_might_take_a_while_prefix": "This might take some time, depending on the size off your file and your internet connection",
  "this_month": "This Month",
  "this_week": "This week",
  "this_year": "This Year",
  "three_dimensional_scan": "3D Scan",
  "thursday": "Thursday",
  "time_frame": "Time Frame",
  "timeframe": "Timeframe",
  "tips": "Tips",
  "title": "Title",
  "title_required": "Need a title",
  "to": "To",
  "today": "Today",
  "to_do": "To do",
  "todo": "To Do",
  "toggle": "Toggle",
  "toggle_node": "Toggle {name}",
  "tomorrow": "Tomorrow",
  "tools": "Tools",
  "total": "Total",
  "total_area_in_management": "Total area in management",
  "total_area_project": "Total area project",
  "total_cost": "Total cost",
  "total_cost_immediate": "Total cost immediate",
  "total_cost_one_to_five_years": "Total cost 1-5 years",
  "try_again": "Try again",
  "tuesday": "Tuesday",
  "turn_off_checklist": "Turn off checklist?",
  "twin": "Twin",
  "two_dimensional_floor_plan": "2D Floor plan",
  "type": "Type",
  "type_building_name": "Type building name",
  "type_comment_placeholder": "Type a comment here",
  "type_room_name": "Type room name",
  "type_value": "Type a value",
  "type_your_comment": "Type your comment",
  "unable_to_show_file": "We are unable to show this type of file",
  "unable_to_unlink_incident": "Unable to unlink from incident",
  "under_hour_ago": "Less than an hour ago",
  "undo": "Undo",
  "undo_discard": "Undo discard",
  "unit": "Unit",
  "unknown": "Unknown",
  "unlink_asset": "{value, plural, one {Unlink asset} other {Unlink assets}}",
  "unlink_entity": "Unlink entity",
  "unlink_file": "{value, plural, one {Unlink file} other {Unlink files}}",
  "unlink_file_description": "{value, plural, one {Unlink the connection with the file } other {Unlink the connection with the files}}",
  "unlink_incident": "Unlink from incident",
  "unlink_incidents": "{count, plural, one {Unlink incident} other {Unlink incidents}}",
  "unlink_successful": "Unlinking have been successful ",
  "unlock_account": "Unlock Account",
  "unsaved_checklist_changes": "You have unsaved changes in your checklist",
  "unsupported_location_type": "Unsupported location type",
  "updated": "Updated",
  "updated_at": "Updated at:",
  "updated_by": "Updated by",
  "updated_date": "Updated date",
  "upload": "Upload",
  "upload_building_picture": "Upload building picture",
  "upload_button_excel_csv": "Click on the upload button to select files to upload. For now you can only upload Excel and .csv files.",
  "upload_button_zip_files": "Click on the upload button to select files to upload. For now you can only upload zip files.",
  "upload_button_zip_files_formats": "Allowed file formats inside archive: {fileTypes}.",
  "uploaded_by": "Uploaded by",
  "uploaded_to_asset": "Uploaded to asset",
  "upload_file": "Upload file",
  "upload_files": "Upload Files",
  "upload_image": "Upload image",
  "upload_images": "Upload images",
  "uploading_status": "Uploading",
  "upload_model": "Upload model",
  "upload_models": "UPLOAD MODELS",
  "upload_models_supported_formats": "Supported file formats: ifc, gltf, glb, dxf, pdf, jpg, png",
  "upload_models_title": "Upload BIM files, 3D scans or floor plans",
  "upload_models_tooltip": "Upload Models",
  "upload_new_files": "UPLOAD NEW FILES",
  "upload_new_version": "Upload a new version",
  "upload_organization_picture": "Upload Organization Picture",
  "upload_org_pic": "Upload organization picture",
  "upload_org_pics": "Upload organization picture",
  "upload_photo": "Upload photo",
  "upload_profile_picture": "Upload Profile Picture",
  "upper": "Upper",
  "up_to_date": "Up to date",
  "usages": "usages",
  "use_cache": "Use Cache",
  "use_of_ai": "Use of AI",
  "user": "User",
  "user_created_success": "User was successfully created",
  "user_deleted_success": "User was deleted successfully",
  "user_management": "User Management",
  "user_management_search_placeholder": "Quick search user",
  "username_for_account": "Username for the account",
  "user_password_recovery_email_confirmation": "An email will be sent to {email} with the reset password link",
  "user_password_recovery_email_sent": "Email with a link to change password is sent to {email}",
  "user_profile": "User profile",
  "users": "Users",
  "users_count": "({count} users)",
  "utilities": "Utilities",
  "validation_field_required": "This field is required",
  "validation_password_lowercase": "1 lowercase letter (a-z)",
  "validation_password_min_length": "8 characters",
  "validation_password_must_contain": "Must contain at least:",
  "validation_password_number": "1 number (0-9)",
  "validation_password_requirements": "Password must be at least 8 characters and contain at least 1 number",
  "validation_password_requirements_full": "Password must contain: At least 8 characters; At least 1 uppercase letter (A-Z); At least 1 lower case letter (a-z); At least 1 number (0-9)",
  "validation_password_requirements_not_met": "Password does not fit requirements",
  "validation_passwords_mismatch": "Passwords do not match",
  "validation_password_uppercase": "1 uppercase letter (A-Z)",
  "value": "Value",
  "value_added_success": "New value added",
  "vendor": "Vendor",
  "ventilation": "Ventilation",
  "version": "Version",
  "vibration": "Vibration",
  "view": "View",
  "view_copied_success": "View copied successfully",
  "view_delete_success": "View {name} has been deleted successfully",
  "view_details": "View details",
  "view_message": "View Message",
  "view_models": "View Models",
  "view_name": "View name",
  "views": "Views",
  "views_not_enabled_description": "Views is not enabled for your organization",
  "views_unavailable": "Views not available",
  "view_team": "View team",
  "visitors": "Visitors",
  "wait_file_loaded": "Please wait while we load your files",
  "waiting": "Waiting",
  "want_to_add_asset": "Want to add an asset?",
  "want_to_add_files": "Want to add files?",
  "want_to_create_incident": "Want to create an incident?",
  "want_to_create_request": "Want to create a request?",
  "want_to_create_views": "Want to create views?",
  "want_to_send_message": "Want to send a message?",
  "warning": "Warning",
  "warranty_expiration": "Expiration of warranty",
  "warranty_expired_date": "Warranty expired date",
  "wc": "WC",
  "wednesday": "Wednesday",
  "week": "Week",
  "what_failed_placeholder": "What failed? Write it here",
  "wo_created": "WO Created",
  "work_list": "Work List",
  "work_order": "Work Order",
  "work_order_added": "Work Order has been added",
  "work_order_dialog_add": "Add Work Order",
  "work_order_dialog_add_existing": "Add existing Work Order",
  "work_order_dialog_complete": "Complete Work Order",
  "work_order_dialog_copy_title": "Copy of {name}",
  "work_order_dialog_create": "Create Work Order",
  "work_order_dialog_create_success": "Work Order has been created successfully",
  "work_order_dialog_delete": "Delete Work Order",
  "work_order_dialog_delete_confirm": "Are you sure you want to delete this work order?",
  "work_order_dialog_deleted": "Work order has been deleted",
  "work_order_dialog_delete_success": "Work Order has been deleted successfully",
  "work_order_dialog_empty_state_click_to_create": "Click on button below to create new work order",
  "work_order_dialog_empty_state_want_to_create": "Want to create work order?",
  "work_order_dialog_multiple_delete_success": "{count} Work Orders have been deleted successfully",
  "work_order_dialog_name_missing_warning": "Please fill in the work order name",
  "work_order_dialog_name_needed": "Work order name must be filled",
  "work_order_dialog_successfully_edited": "Work order successfully edited",
  "work_order_dialog_unlinked": "Work order has been unlinked",
  "work_order_dialog_warning": "Work order name must be filled",
  "work_order_edit_success": "Work Order name edited successfully",
  "workorder_id": "Work order ID",
  "work_order_missing_warning": "Please fill the work order name",
  "work_order_name_needed": "Work Order name must be filled in",
  "work_order_not_found": "Work order not found",
  "work_orders": "Work Orders",
  "work_orders_duplicated_success": "Work Orders have been duplicated successfully",
  "work_orders_empty_warning": "Work orders is empty",
  "work_orders_selected": "Work Orders Selected",
  "work_order_successfully_edited": "Work Order successfully edited",
  "work_order_unlinked": "Work Order has been unlinked",
  "work_order_warning": "Work Order Name must be filled",
  "workspace": "Workspace",
  "write_message_here": "Write message here",
  "wrong": "Wrong",
  "wrong_email_format": "Wrong Email Format",
  "year": "Year",
  "year_hint": "YYYY",
  "years": "Years",
  "yes": "Yes",
  "yesterday": "Yesterday",
  "yesterday_with_time": "Yesterday at {time}",
  "zone_assets_group_description": "Click on them for see more assets or use checkbox for choose asset as part of zone",
  "zone_created_success": "Zone was successfully created",
  "zone_edited_success": "Zone was successfully edited",
  "zone_name": "Zone Name",
  "zones": "Zones",
  "zones_name": "Zone Name"
}